<div *ngIf="false" class="status">
    <div class="title">
      <img src="/assets/icons/error.svg" alt="Sin resultados de búsqueda">
      No se encontraron resultados
    </div>
    <div class="text">
        Lo sentimos! no se encontraron resultados, por favor vuelve a intentarlo más tarde
    </div>
</div>

<div class="status">
    <div class="title">
      <img src="/assets/icons/success.svg" alt="Cliente sin deuda registrada">
      Cliente no registra deuda
    </div>
    <div class="text">
        Si necesitas más información o requieres resolver dudas técnicas o comerciales visita: Contactar con soporte
    </div>
</div>
